import script from "./PrescriptionProcess.vue?vue&type=script&setup=true&lang=js"
export * from "./PrescriptionProcess.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__